import { ApolloClient, InMemoryCache, from } from '@apollo/client';
import { createOnErrorLink } from './links/createOnErrorLink';
import { createAPILink } from './links/createAPILink';
import { createZGGraphSwitcherLink } from './links/createZGGraphSwitcherLink';

const client = new ApolloClient({
    link: from([createZGGraphSwitcherLink(), createOnErrorLink(), createAPILink()]),
    cache: new InMemoryCache(),
    ssrMode: !globalThis.window,
});

export { client };
